export function getUrlParametersToString(
  urlParameter: URLSearchParams,
): string {
  const param =
    Array.from(urlParameter).length === 0 ? '' : '?' + urlParameter.toString()
  return param
}
